import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import { Button, Input, Row, Card, Spacer, Field } from '@oliasoft-open-source/react-ui-library';
import { autoSaveWait } from 'src/config/config';
import translations from 'src/internationalisation/translation-map.json';
import { formatFromApiDate, formatFromApiTime, formatToApiDateTime } from 'src/views/time-tracker/utils/date/dateUtils';

const DateTimePicker = ({ firstOperation, updateTrackerStartTime, updateStartTime, close }) => {
  const { t } = useTranslation();

  const startDate = firstOperation?.start;
  const [datePickerValue, setDatePickerValue] = useState('');
  const [timePickerValue, setTimePickerValue] = useState('');
  const [editMode, setEditMode] = useState(true);

  useEffect(() => {
    setDatePickerValue(formatFromApiDate(startDate));

    setTimePickerValue(formatFromApiTime(startDate));
  }, [startDate]);

  const onDatePickerChange = (evt) => setDatePickerValue(evt.target.value);
  const onTimePickerChange = (evt) => {
    setTimePickerValue(evt.target.value);
  };
  const debounceUpdateTrackerStartTime = useRef(debounce(updateTrackerStartTime, autoSaveWait));

  const onPickerConfirm = () => {
    const startTime = formatToApiDateTime(
      datePickerValue,

      timePickerValue,
    );
    updateStartTime(startTime);
    setEditMode(false);
    debounceUpdateTrackerStartTime.current(startTime);
    close();
  };
  const onPickerCancel = () => {
    setDatePickerValue(formatFromApiDate(startDate));

    setTimePickerValue(formatFromApiTime(startDate));
    setEditMode(false);
    close();
  };

  return (
    editMode && (
      <Card padding={false} bordered={false}>
        <Row>
          <Field label={t(translations.timeTracker_startDate)}>
            <Input
              type="date"
              value={datePickerValue}
              onChange={onDatePickerChange}
              testId="date-time-picker-date-input"
            />
          </Field>

          <Spacer width="var(--padding-sm)" />

          <Field label={t(translations.timeTracker_startTime)}>
            <Input
              testId="date-time-picker-time-input"
              type="time"
              size="20"
              onChange={onTimePickerChange}
              value={timePickerValue}
            />
          </Field>
        </Row>
        <Row justifyContent={'center'} marginTop="var(--padding-xs)">
          <Button colored small={true} testId="date-time-picker-ok-button" label="OK" onClick={onPickerConfirm} />
          <Spacer width="var(--padding-sm)" />
          <Button small={true} label="Cancel" onClick={onPickerCancel} />
        </Row>
      </Card>
    )
  );
};

export { DateTimePicker };
